<template>
  <div :class="classInput">
    <div class="form-group">
      <label class="label" :class="{'required': isRequired}">{{ label }}</label>
      <input
        :value="value"
        v-mask="'##.###.###/####-##'"
        type="text"
        class="form-control"
        @change="validCNPJ()"
        @blur="() => validate()"
        :class="{ 'is-invalid': errorCNPJ || isInvalid}"
        @input="$emit('input', $event.target.value)"
      >
      <div
        v-if="errorCNPJ || isInvalid"
        class="invalid-feedback"
      >
        <span v-if="errorCNPJ">CNPJ inválido.</span>
        <span v-if="isInvalid">Campo obrigatório.</span>
      </div>
    </div>
  </div>
</template>

<script>
import { cnpj } from 'cpf-cnpj-validator'

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    typeInput: {
      type: String
    },
    value: {
      type: String
    },
    classInput: {
      type: String,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      errorCNPJ: false,
      isInvalid: false,
      hasTouched: false
    }
  },
  methods: {
    validCNPJ () {
      const cnpjValid = cnpj.isValid(this.value)
      if (!cnpjValid) {
        this.errorCNPJ = true
        return
      }
      this.errorCNPJ = false
    },
    validate () {
      this.isInvalid = (this.hasTouched && this.value === null) || (this.isRequired && !this.value)
    },
    isValid () {
      this.validate()
      return !this.isInvalid
    }
  }
}
</script>
